import React, { useState, useEffect, Fragment, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import "./Header.scss";
import { useSelector, useDispatch } from 'react-redux'
import "../../utils/select2_4.0.js";
import $ from 'jquery';
import "../../assets/VagaroStyle/select2.css"
import {
     GetBusinessDetails, Logout
} from '../../components/Slice/Business'
import { LoginUserType } from "../../utils/Utils";
import { utils } from "../../utils/Utils";

const Header = (props) => {

     const { ReactBusinessId, BusinessName, Image, PhotoForInitials, UserType, EncryptionCode, IsMultiple, UserName, IsViewAllowed, IsModifyAllowed, UserID, BusinessID,  EncUBID } = useSelector((state) => state.Business);

     const toggle = useRef(true);
     const [show, setShow] = useState(false);
     const showDropdown = (e) => {
          setShow(!show);
     }
     const hideDropdown = e => {
          setShow(false);
     }

     const logoDropdown = React.forwardRef(({ children, onClick }, ref) => (
          <a
               href=""
               ref={ref}
               className="toggleimg"
               onClick={(e) => {
                    e.preventDefault();
                    onClick(e);
               }}>
               {children}

          </a>
     ));

     const Vglogo = () => (
          <div className="">
               <Dropdown>
                    <Dropdown.Toggle as={logoDropdown} id="dropdown-basic"
                         onMouseEnter={showDropdown}
                         onMouseLeave={hideDropdown}>
                         <img alt="Vagaro" src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/VagaroLogo_wb.svg" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                         <Dropdown.Item target={"_blank"} href={"https://www.vagaro.com/Default.aspx"}>Vagaro.com</Dropdown.Item>
                         <Dropdown.Item target={"_blank"} href={"https://www.vagaro.com/pro/vagaro-app"}>Vagaro Mobile Apps</Dropdown.Item>
                         <Dropdown.Item target={"_blank"} href="https://blog.vagaro.com/pro/">Pro Blog</Dropdown.Item>
                    </Dropdown.Menu>
               </Dropdown>
          </div>
     );


     let $select2Businessobject = null;
     let totalrecords = 0;
     const dispatch = useDispatch();

     const access_token = useSelector((state) => state.Token.access_token);
     const header = {
          "Content-Type": "application/json",
          //"Authorization": "Bearer " + access_token
     };

     const Bindlist = () => {
          if (toggle.current) {
               $select2Businessobject = $("#txtSearch").select2({
                    placeholder: "Search",
                    minimumInputLength: 0,
                    addSelectedClass: true,
                    defaultselectedid: EncryptionCode,
                    combobox: true,
                    templateResult: function (obj) {
                         if (!obj.id) {
                              return obj.text;
                         }
                         var $obj = "";
                         obj.ismultilocationgroup = JSON.parse(obj.ismultilocationgroup);
                         if (obj.ismultilocationgroup) {
                              $obj = $('<b data-ismultilocationgroup="' + obj.ismultilocationgroup + '" data-multilocationgroupid="' + obj.multilocationgroupid + '">' + obj.text + '</b>');
                              $obj.disabled = true;
                         }
                         else {
                              if (obj.multilocationgroupid > 0) {
                                   $obj = $('<div class="nested" data-placeid="' + obj.id + '">' + obj.text + '</div>');
                              }
                              else {
                                   $obj = $('<div data-placeid="' + obj.id + '">' + obj.text + '</div>');
                              }
                         }
                         return $obj;
                    },
                    ajax: {
                         url: window.VagaroCoreApiUrl + "merchants/bussinesslist",
                         dataType: 'json',
                         headers: header,
                         quietMillis: 250,
                         data: function (params) {
                              return {
                                   search: params.term == undefined ? "" : params.term,
                                   pageindex: params.page || 1,
                                   pagesize: 5,
                                   UserID: UserID,
                                   BusinessID: BusinessID,
                                   EncUBID: EncUBID,
                                   IsViewAllowed: IsViewAllowed,
                                   IsModifyAllowed: IsModifyAllowed
                              };
                         },
                         processResults: function (data, params) {
                              let businessList = [];
                              data.data.map((d) => {
                                   var objdata = {};
                                   objdata.id = d.encryptionCode;
                                   objdata.text = d.businessName;
                                   objdata.ismultilocationgroup = d.isMultilocationGroup;
                                   objdata.multilocationgroupid = d.multiLocationGroupID;
                                   objdata.disabled = d.isMultilocationGroup ? true : false;
                                   businessList.push(objdata);
                              });
                              params.page = params.page || 1;
                              var intpageSize = 5;
                              if (data != null && data.data != null && data.data.length === 0) {
                                   totalrecords = 0;
                              }
                              else {
                                   totalrecords = data != null && data.data != null ? data.data[0].total_count : 0;
                              }
                              var intTotalPages = Math.ceil(totalrecords / intpageSize);
                              let displayItems = intpageSize * params.page;
                              if (params.page == intTotalPages) //This is last page and it can have less records than page size (20)
                              {
                                   displayItems = totalrecords;
                              }
                              var more = false;
                              return {
                                   results: data == null ? null : businessList,
                                   pagination: {
                                        more: (displayItems < totalrecords)
                                   }
                              };
                         },
                    },
                    formatNoMatches: function () {
                         $("#select2-drop").css("display", "block");
                         return "No matches found";
                    },
                    formatSearching: function () {
                         $("#select2-drop").css("display", "block");
                         return "Searching…";
                    },
                    formatInputTooShort: function (input, min) {
                         $("#select2-drop").css("display", "none");
                         return "";
                    },
                    formatResult: function (repo) {
                         $("#searchsalon-spas").show();
                         $("#select2-drop").css("display", "block");
                         var markup = '<div data-placeid="' + repo.id + '">' + repo.text + '</div>';
                         return markup;
                    },
               });
               $select2Businessobject.on('select2:open', function (e) {
                    $(".select2-container").addClass("selectbusiness searchContainer");
               });
               $select2Businessobject.change(function () {
                    if ($select2Businessobject.select2('data')[0].id != undefined && $select2Businessobject.select2('data')[0].id != "") {
                         changeBusiness($select2Businessobject.val());
                         $select2Businessobject.select2('data')[0].id = "";
                    }
               });
               LoadBusinessList();
               toggle.current = false;
          }
          else {
               toggle.current = true;
          }
     }
     const changeBusiness = (EncryptCode) => {
          if (utils.Validate(access_token)) {
               toggle.current = true;
               const Requestdata = {};
               Requestdata.EncryptCode = EncryptCode;
               Requestdata.access_token = access_token;
               dispatch(GetBusinessDetails(Requestdata));
          }
     }

     const LoadBusinessList = () => {
          if ($select2Businessobject != undefined) {
               var select2 = $select2Businessobject.data('select2');
               select2.open();
          }
     }

     const AvtarToggle = React.forwardRef(({ children, onClick }, ref) => (
          <div
               id="divUserPhoto"
               className="nav-profile-photo vagaro-avatar-sm opacity-1"
               role="link"
               tabIndex={-1}
               aria-label="Navigation bar"
               data-original={Image}
               ref={ref}
               onClick={(e) => {
                    e.preventDefault();
                    onClick(e);
               }}
               style={{
                    display: "block",
                    backgroundImage: "url('" + Image + "')",
               }}
          >
               {children}

          </div>
     ));

     const navigate = useNavigate();
     const LogoutBusiness = () => {
          dispatch(Logout());
          navigate("/loggedout");
     }
     return (
          ReactBusinessId >= 0 && <header className="builder-header">
               <div className="vagaro-logo-leftnav">
                    {props.IsShowToggle == false ? <a href="/" class="toggleimg"><img src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/VagaroLogo_wb.svg"></img></a> : <Vglogo />}
               </div>
               <div className="logged-user-block">

                    <div className="business-name">
                         {ReactBusinessId > 0 && IsMultiple &&
                              <div className="businessName-trigger" onClick={Bindlist}>{BusinessName}</div>
                         }
                         {ReactBusinessId > 0 && IsMultiple == false &&
                              <div className="businessName-trigger">{BusinessName}</div>
                         }
                         {ReactBusinessId == 0 && UserType === LoginUserType.VagaroAdmin &&
                              <div className="businessName-trigger" onClick={Bindlist}>{UserName}</div>
                         }
                         <div className="bfk-element searchsalon-spas">
                              <select id="txtSearch" name="select" className="selectbusinesscont">
                              </select>
                         </div>
                    </div>
                    <div className="user-avatar">
                         <Dropdown>
                              <Dropdown.Toggle as={AvtarToggle} id="userToggleMenu">
                                   <div
                                        className="avatar-inital intialsname vg-avatar-inital"
                                        aria-hidden="true"
                                        style={{ display: Image === "" ? "block" : "none" }}
                                   >
                                        <div className="avatar-inital-inner vg-avatar-inital-inner">
                                             <div className="avatar-inital-inner-text loginUserIntials vg-avatar-inital-inner-text">
                                                  {PhotoForInitials}
                                             </div>
                                        </div>
                                   </div>
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="userMenu">
                                   <Dropdown.Item onClick={() => LogoutBusiness()} >Logout</Dropdown.Item>
                              </Dropdown.Menu>
                         </Dropdown>
                    </div>
               </div>
          </header>
     )
}

export default Header;
